<template>
  <div class="register">
    <header>
      <nav class="site-navbar">
        <div class="site-navbar__header" style="width: 500px;">
          <h1 class="site-navbar__brand" @click="$router.push({ name: 'home' })">
            <a class="site-navbar__brand-lg" href="javascript:;"><span style="padding-left: 10px">黄石市公共资源交易主体库</span></a>
            <a class="site-navbar__brand-mini" href="javascript:;"><img src="~@/assets/img/logo.png" style="height: 34px;" alt=""></a>
          </h1>
        </div>
      </nav>
    </header>
    <el-card class="box-card">
      <nav>
        <stepCom ref="stepsChild" :stepsData="stepsData" :stepsIndex="active" />
      </nav>
      <main>
        <One v-if="active == 0"></One>
        <div v-if="active == 1" class="fillRegisterInfo">
          <el-form label-width="220px" :model="form" ref="form" :rules="rules">
            <div class="fillRegisterInfo_box">
              <div class="fillRegisterInfo_box_title"><p><span>账号信息</span></p></div>
                <el-form-item label="用户名：" prop="loginName" :key="1">
                  <el-input v-model="form.loginName" size="small" placeholder="请输入登录用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="passWord" :key="2">
                  <el-input v-model="form.passWord" size="small" auto-complete="new-password" show-password placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="confirmPassword" :key="3">
                  <el-input v-model="form.confirmPassword" size="small" auto-complete="new-password" show-password placeholder="请再次输入密码"></el-input>
                </el-form-item>
                <el-form-item label="密码提示信息：" prop="passWordRemind" :key="4">
                  <el-input v-model="form.passWordRemind" size="small" placeholder="将在登录时显示,帮助您回忆密码"></el-input>
                </el-form-item>
            </div>
            <div class="fillRegisterInfo_box">
              <div class="fillRegisterInfo_box_title"><p><span>交易主体信息</span></p></div>
                <el-form-item label="交易主体类型：" prop="mainType" :key="5">
                  <el-radio-group @change="selectRadio" v-model="form.mainType">
                    <el-radio label="1">法人（企业）</el-radio>
                    <el-radio label="2">自然人</el-radio>
                  </el-radio-group>
                </el-form-item>
  <!--              法人的输入内容-->
                <el-form-item v-if="form.mainType == 1" label="企业名称：" prop="entName" :key="6">
                  <el-input v-model="form.entName" size="small" placeholder="请输入营业执照上的企业名称"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 1" label="统一社会信用代码：" prop="mainCode" :key="7">
                  <el-input v-model="form.mainCode" size="small" placeholder="请输入营业执照上的18位统一社会信用代码"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 1" label="信息申报人：" prop="declarant" :key="8">
                  <el-input v-model="form.declarant" size="small" placeholder="请输入填报企业信息的人员姓名"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 1" label="申报人手机号：" prop="linkPhone" :key="9">
                  <el-input v-model="form.linkPhone" size="small" placeholder="用于找回密码及接收短信通知"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 1" label="手机验证码：" prop="smsVerificationCode" :key="10">
                  <el-input v-model="form.smsVerificationCode" class="vrification" size="small"></el-input>
                  <span v-if="isSend" @click="sendCode" style="position: absolute; right: 170px;color: #1890FF;font-size: 14px;cursor: pointer;">发送验证码</span>
                  <span v-if="!isSend" style="position: absolute; right: 150px;color: #999;font-size: 14px;cursor: pointer;">请 {{count}}s 后再试</span>
                </el-form-item>
  <!--              自然人的输入内容-->
                <el-form-item v-if="form.mainType == 2" label="姓名：" prop="userName" :key="11">
                  <el-input v-model="form.userName" size="small" placeholder="请输入身份证上的姓名"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 2" label="身份证号：" prop="idCard" :key="12">
                  <el-input v-model="form.idCard" size="small" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 2" label="手机号：" prop="linkPhone" :key="13">
                  <el-input v-model="form.linkPhone" size="small" placeholder="用于找回密码及接收短信通知"></el-input>
                </el-form-item>
                <el-form-item v-if="form.mainType == 2" label="手机验证码：" prop="smsVerificationCode" :key="14">
                  <el-input v-model="form.smsVerificationCode" class="vrification" size="small"></el-input>
                  <span v-if="isSend" @click="sendCode" style="position: absolute; right: 170px;color: #1890FF;font-size: 14px;cursor: pointer;">发送验证码</span>
                  <span v-if="!isSend" style="position: absolute; right: 150px;color: #999;font-size: 14px;cursor: pointer;">请 {{count}}s 后再试</span>
                </el-form-item>
            </div>
            <div class="fillRegisterInfo_box">
              <div class="fillRegisterInfo_box_title"><p><span>注册附件</span></p></div>
                <el-form-item label="信用承诺书：" prop="fileList1" :key="15">
                  <docUploadForm
                          :type="type"
                          :index="0"
                          :docItem.sync="form.attachmentParamList[0]"
                          :fileLists.sync="form.fileList1"
                          prop="fileList1"
                          name="上传附件"
                  />
                </el-form-item>
                <el-form-item v-if="isUpload" label="法人授权委托书：" prop="fileList2" :key="16">
                  <docUploadForm
                          :type="type"
                          :index="1"
                          :docItem.sync="form.attachmentParamList && form.attachmentParamList[1]"
                          :fileLists.sync="form.fileList2"
                          prop="fileList2"
                          name="上传附件"
                  />
                </el-form-item>
                <div class="part">
                  <div class="part_title">模版下载：</div>
                  <div class="part_cont">
                    <a href="https://gcjs.hsztbzx.com:443/template/t_p_template/湖北省公共资源招标投标事前信用承诺书（范本）.docx"><h3><u>《湖北省公共资源招标投标事前信用承诺书（范本）》</u></h3></a>
                    <a href="https://gcjs.hsztbzx.com:443/template/t_p_template/法人授权委托书.doc"><h3><u>《法人授权委托书》</u></h3></a>
                  </div>
                </div>
            </div>
          </el-form>
        </div>
        <div v-if="active == 2" class="resultPage">
          <div class="success_top">
            <span><img src="../../../src/assets/img/login/result_success.png"></span>
            <p>恭喜你，完成注册！</p>
            <div class="action_btn">
              <el-button size="small" style="margin-right: 16px" @click="goFilePath">下载回执</el-button>
              <el-button type="primary" @click="goLogin" size="small">返回登录</el-button>
            </div>
          </div>
          <div class="success_bottom">
            <p><i class="el-icon-info" style="color: skyblue;margin-left: 20px; margin-right: 9px;"></i>以下注册信息请妥善保管，请返回登录系统完成主体信息登记。</p>
            <el-form style="margin: 20px 100px 0 110px;" label-width="140px">
              <el-form-item label="用户名：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.loginName }}</span>
              </el-form-item>
              <el-form-item label="密码提示信息：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.passWordRemind }}</span>
              </el-form-item>
              <el-form-item label="交易主体类型：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.mainType == 1 ? '法人' : dataInfo.mainType == 2 ? '自然人' : '' }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 1" label="企业名称：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.entName }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 1" label="统一社会信用代码：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.mainCode }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 1" label="信息申报人：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.declarant }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 1" label="申报人手机号：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.linkPhone }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 2" label="姓名：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.userName }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 2" label="身份证号：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.idCard }}</span>
              </el-form-item>
              <el-form-item v-if="dataInfo.mainType == 2" label="手机号：">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ dataInfo.linkPhone }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </main>
      <footer class="Btn">
        <el-button v-if="active == 0" @click="goBack" size="small">不同意</el-button>
        <el-button v-if="active == 0" type="primary" :class="time >=0 ? 'btn-able' : 'btn-noAble'" @click="next" size="small">同意 <span v-if="time >= 0">{{time}}s</span></el-button>
        <el-button v-if="active == 1" @click="backStep" size="small">上一步</el-button>
        <el-button v-if="active == 1" type="primary" @click="submit('form')" size="small">提交</el-button>
      </footer>
    </el-card>
    <div style="height: 40px"></div>
  </div>
</template>

<script>
  import One from './registerMent/one'
  export default {
    name: "register",
    data() {
      // 登录名校验
      let validateName = (rule, value, callback) => {
        let reg= /^[\w\u4e00-\u9fa5]{5,20}$/;
        if (!reg.test(value)) {
          callback(new Error('用户名必须是数字加字母且为5-20位'));
        } else {
          callback();
        }
      };
      // 身份证号校验校验
      let validateIdCard = (rule, value, callback) => {
        // let reg= /(^\\d{18}$)|(^\\d{15}$)|(^\\d{17}(\\d|X|x)$)/;
        let reg= /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的身份证号'));
        } else {
          callback();
        }
      };
      // 统一社会信用代码校验
      let validateMainCode = (rule, value, callback) => {
        let reg= /[A-Z0-9]{18}/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的统一社会信用代码'));
        } else {
          callback();
        }
      };
      // 密码校验
      let validatePass = (rule, value, callback) => {
        let reg= /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z_\\*\\$@`\\!\\#\\%\\^\\&]{8,16}$/;
        if (!reg.test(value)) {
          callback(new Error('至少8-16个字符，至少1个大写字母，1个小写字母和1个数字,不能包含特殊字符（非数字字母）'));
        } else {
          if (this.form.confirmPassword !== '') {
            this.$refs.form.validateField('confirmPassword');
          }
          callback();
        }
      };
      // 确认密码
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.passWord) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      // 手机号校验
      let checkPhone = (rule,value,callback) => {
        if(!value) {
          return callback(new Error('手机号不能为空'));
        }else{
          const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
          if(reg.test(value)) {
            callback();
          }else{
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return {
        type: 'ent_base_info',
        active: 0,
        time: 10,
        count:'',
        isSend: true,
        timer:null,
        isUpload:true,
        dataInfo:{},
        fileUrl:'',
        form:{
          loginName:'',
          passWord:'',
          confirmPassword:'',
          mainType: '1',
          entName: '',
          userName:'',
          mainCode:'',
          idCard:'',
          declarant:'',
          linkPhone:'',
          smsVerificationCode:'',
          userTypes:'',
          verificationCode:'',
          sysCaInfoVo:'',
          remark:'',
          roleType:'',
          passWordRemind:'',
          attachmentParamList: [{
            required: true,
            Id: "",
            citeId: "",
            name: "",
            fileType: 1,
            filePath: "",
            extendName: '.pdf',
            attributes: {
              attname: "",
              delmethod: "2",
              allows: '.pdf',
            }
          },{
            required: true,
            Id: "",
            citeId: "",
            name: "",
            fileType: 1,
            filePath: "",
            extendName: '.pdf',
            attributes: {
              attname: "",
              delmethod: "2",
              allows: '.pdf',
            }
          }],
          fileList1:[],
          fileList2:[],
        },
        rules: {
          loginName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { validator: validateName, trigger: 'blur' }
          ],
          passWord: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ],
          passWordRemind: [
            { required: true, message: '请输入密码提示信息', trigger: 'blur' }
          ],
          mainType: [
            { required: true, message: '请选择交易主体类型', trigger: 'change' }
          ],
          entName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' }
          ],
          mainCode: [
            { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
            { validator: validateMainCode, trigger: 'blur' }
          ],
          declarant: [
            { required: true, message: '请输入信息申报人姓名', trigger: 'blur' }
          ],
          linkPhone: [
            { required: true, validator: checkPhone, trigger: 'blur' }
          ],
          smsVerificationCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
          userName: [
            { required: true, message: '请输入您的姓名', trigger: 'blur' }
          ],
          idCard: [
            { required: true, message: '请输入您的身份证号', trigger: 'blur' },
            { validator: validateIdCard, trigger: 'blur' }
          ],
          fileList1: [
            {required: true, message: '请上传信用承诺书附件', trigger: 'change'}
          ],
          fileList2: [
            {required: true, message: '请上传法人授权委托书附件', trigger: 'change'}
          ],
        },
        stepsData:[
          {name:'注册章程'},
          {name:'填写注册信息'},
          {name:'完成注册'},
        ]
      }
    },
    components:{
      One
    },
    created() {
      // 同意按钮倒计时
      window.setInterval(() => {
        this.time--
      },1000)
    },
    provide(){
      return {
        uploadSuccess: this.uploadSuccess
      }
    },
    methods: {
      uploadSuccess(prop) {
        if(this.$refs.form){
          this.$nextTick(() => {
            this.$refs.form.validateField(prop)
          })
        }
      },
      // 不同意
      goBack() {
        this.$router.go(-1);
      },
      // 同意
      next() {
        if(this.time >=0){
          return
        }else{
          this.active++;
        }
      },
      // 上一步
      backStep() {
        this.active--;
      },
      // 监听企业类型
      selectRadio(value) {
        if(value == 1){
          this.isUpload = true;
          this.form.userName = '';
          this.form.idCard = '';
          this.form.linkPhone = '';
          this.form.smsVerificationCode = '';
          this.form.attachmentParamList= [{
            required: true,
            Id: "",
            citeId: "",
            name: "",
            fileType: 1,
            filePath: "",
            extendName: '.pdf',
            attributes: {
              attname: "",
              delmethod: "2",
              allows: '.pdf',
            }
          },{
            required: true,
            Id: "",
            citeId: "",
            name: "",
            fileType: 1,
            filePath: "",
            extendName: '.pdf',
            attributes: {
              attname: "",
              delmethod: "2",
              allows: '.pdf',
            }
          }];
          this.form.fileList2 = [];
        }else if(value == 2){
          this.isUpload = false;
          this.form.entName = '';
          this.form.mainCode = '';
          this.form.declarant = '';
          this.form.linkPhone = '';
          this.form.smsVerificationCode = '';
          this.form.attachmentParamList.splice(1,1)
          delete this.form.fileList2;
        }
      },
      // 提交
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$refs[formName].validateField('fileList1');
            this.$refs[formName].validateField('fileList2');
            this.$http.post('/register/save',this.form).then((res) => {
              if(res.data && res.data.code == 1){
                this.next();
                this.dataInfo = res.data.data;
                this.$http.get('/get/fileUrl').then((res)=>{
                  if(res.data && res.data.code == 1){
                    this.fileUrl = res.data.data;
                  }
                })
              }else{
                this.$notify({
                  title: '提交信息',
                  message: res.data.msg,
                  position: 'bottom-right',
                  type: 'warning'
                })
              }
            })
          } else {
            return false;
          }
        });
      },
      // 返回登录
      goLogin(){
        this.$router.push({path:'/login'})
      },
      // 发送验证码
      sendCode() {
        const timeCount = 300;
        this.$http.post('/register/getSms',{
          linkPhone:this.form.linkPhone
        }).then((res) => {
          if(res.data && res.data.code == 1){
            this.isSend = false;
            this.count = timeCount;
            this.timer = setInterval(()=>{
              if(this.count >0 && this.count <= timeCount){
                this.count --;
              }else{
                this.isSend = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            },1000);
            this.$notify({
              title: '发送验证码',
              message: res.data.msg,
              position: 'bottom-right',
              type: 'success'
            })
          }else{
            this.$notify({
              title: '发送验证码',
              message: res.data.msg,
              position: 'bottom-right',
              type: 'warning'
            })
          }
        })
      },
      goFilePath() {
        if(!!this.dataInfo.downFilePath){
          window.location.href = this.fileUrl + this.dataInfo.downFilePath
        }else{
          return
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-input__suffix{
    right: 170px;
  }
  /deep/ .el-input__inner {
    width: 436px;
  }
  .vrification{
    position: relative;
    /deep/ .el-input__inner {
      width: 354px;
    }
  }
  /deep/ .affix{
    margin: 0 0 0 0;
  }
  /deep/ .affix .el-form .doc-btn label{
    width: 111px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    line-height: 32px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  /deep/ .title_name p{
    line-height: 40px !important;
  }
  body{
    background: #F0F2F5;
    .box-card{
      width: 1300px;
      background: #FFFFFF;
      border: 1px solid #D8D8D8;
      margin: 74px auto 0;
      .task-main-box {
        width: 100%;
        height: calc(100% - 45vh);
        .task-con-box {
          width: 100%;
          height: 100%;
        }
      }
      .Btn{
        margin-top: 32px;
        .btn-able{
          opacity: 0.5;
        }
      }
      nav{
        width: 924px;
        margin: 0 auto;
      }
      main{
        a{
          color: #1890FF;
          h3{
            height: 30px;
            border-bottom:none;
            padding: 0;
            u{
              font-size: 12px;
            }
          }
        }
        a, a:hover, a:link, a:focus, a:active {
          text-decoration: none;
        }
        .fillRegisterInfo{
          width: 824px;
          margin: 0 auto;
          .fillRegisterInfo_box{
            .fillRegisterInfo_box_title{
              margin-bottom: 30px;
              margin-top: 40px;
              p{
                width: 824px;
                height: 40px;
                background: #EFF3F6;
                font-size: 18px;
                font-family: MicrosoftYaHei;
                color: #000000;
                line-height: 40px;
                span{
                  margin-left: 16px;
                }
              }
            }
            .part{
              display: flex;
              margin-left: 138px;
              padding-top: 10px;
              .part_title{
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
              }
              .part_cont{
                margin-top: -3px;
              }
            }
          }
        }
        .resultPage{
          width: 824px;
          margin: 0 auto;
          .success_top{
            width: 824px;
            margin: 0 auto;
            span{
              display: inline-block;
              width: 72px;
              height: 72px;
              margin-top: 48px;
              margin-left: 376px;
            }
            p{
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.85);
              text-align: center;
              margin-top: 24px;
              margin-left: 20px;
            }
            .action_btn{
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 32px;
            }
          }
          .success_bottom{
            margin-top: 24px;
            border-top: 1px solid #EEEEEE;
            p{
              width: 608px;
              height: 40px;
              background: #ECF5FF;
              margin: 27px auto 0;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #000000;
              line-height: 40px;
            }
            /deep/ .el-form-item{
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
</style>
